import React from 'react';
import QRCode from 'react-qr-code';

type PropsQRCodeGeberate = {
  value: string;
  size: number;
  bgColor?: string;
  fgColor?: string;
  level?: 'L' | 'M' | 'Q' | 'H';
};

const QRCodeGenerate = ({
  value,
  size = 128,
  bgColor = '#FFFFFF',
  fgColor = '#000000',
  level = 'L',
}: PropsQRCodeGeberate) => {
  return (
    <QRCode
      value={value}
      size={size}
      bgColor={bgColor}
      fgColor={fgColor}
      level={level}
    />
  );
};

export default QRCodeGenerate;
